import React from 'react'
import styled from '@emotion/styled'
import Icon from 'shared/library/atoms/Icon'

interface ModalFieldProps {
  children: React.ReactNode
  onClick: () => void
  hasValues: boolean
  disabled?: boolean
  gaid?: string
}

const ModalField = ({
  children,
  hasValues,
  disabled = false,
  gaid,
  ...other
}: ModalFieldProps) => {
  return (
    <StyledInputButton
      type="button"
      disabled={disabled}
      {...other}
      data-gaid={gaid}
    >
      {children}
      {!disabled && (
        <Icon name={hasValues ? 'check' : 'add'} color={'primary'} size={16} />
      )}
    </StyledInputButton>
  )
}

export default ModalField
// disabled already exists as a prop on button and will appropriately disable it.
const StyledInputButton = styled.button(({ theme, disabled }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.mixins.pxSpread([
    theme.space[2],
    theme.space[4],
    theme.space[2],
    theme.space[4]
  ]),
  cursor: disabled ? 'default' : 'pointer',
  width: '100%',
  color: disabled ? theme.colors.text.tertiary : theme.colors.primary,
  background: theme.colors.background.secondary,
  border: disabled ? `1px solid ${theme.colors.white}` : theme.border,
  borderRadius: theme.radii[3]
}))
